import type { FC } from 'react';
import { Calendar } from 'react-date-range';
import type { Locale } from 'date-fns';
import type { AllieSingleDateCalendarProps } from '../../AllieSingleDateCalendar.types';
import { ReactDateRangeCalendarRoot } from './ReactDateRangeSingleCalendar.styles';
import './reactDateRangeTheme';

export const ReactDateRangeSingleCalendar: FC<AllieSingleDateCalendarProps> = ({
  value,
  onChange,
  locale,
  minDate,
  maxDate,
}) => {
  const handleChange = (date: Date) => {
    onChange(date);
  };

  return (
    <ReactDateRangeCalendarRoot>
      <Calendar
        date={value}
        onChange={handleChange}
        locale={locale as Locale}
        minDate={minDate}
        maxDate={maxDate}
        months={1}
        showMonthAndYearPickers
        showDateDisplay={false}
      />
    </ReactDateRangeCalendarRoot>
  );
};

ReactDateRangeSingleCalendar.displayName = 'ReactDateRangeSingleCalendar';
